import type { ReactElement, ReactNode } from 'react';
import { Fragment } from 'react';

import classNames from 'classnames';

import type { OneOrMany } from '@utilities/helpers/OneOrMany';

interface TabularRowProps {
  label: string;
  children?: ReactNode;
}

interface TabularProps {
  children?: OneOrMany<ReactElement<TabularRowProps>>;
  className?: string;
}

/**
 * Tabular is a layout primititve that renders a grid with two columns and
 * an arbitrary number of rows such that the content in every cell in the left column is
 * centered vertically and justified to the left, while the content in every cell in the right column
 * is centered vertically and justified to the right.
 */
const Tabular = ({ children, className }: TabularProps) => {
  return <div className={classNames('tabular', className)}>{children}</div>;
};

const TabularRow = ({ label, children }: TabularRowProps) => {
  return (
    <Fragment>
      <div className="label flex flex-row items-center">{label}</div>

      <div className="content flex flex-row justify-end items-center">{children}</div>
    </Fragment>
  );
};

TabularRow.displayName = 'Tabular.Row';

Tabular.Row = TabularRow;

export { Tabular };
